// src/utils/calculateMetrics2.js
// src/utils/calculateMetrics2.js

// tiny helper to coerce to number safely
const n = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export function calculateMetrics2(data = {}) {
  const metrics = {};

  // ---------------------------
  // KNOW_HIV (normalize like backend: 98/missing -> 0)
  // ---------------------------
  if (
    data.KNOW_HIV === 98 ||
    data.KNOW_HIV === "98" ||
    data.KNOW_HIV === undefined ||
    data.KNOW_HIV === null ||
    data.KNOW_HIV === ""
  ) {
    metrics.KNOW_HIV = 0;
  } else {
    metrics.KNOW_HIV = n(data.KNOW_HIV);
  }

  // ---------------------------
  // YOUTH_SEXPARTNERS
  // (<2 => 2, 98 => 0, else passthrough; default 0)
  // ---------------------------
  if (data.YOUTH_SEXPARTNERS !== undefined && data.YOUTH_SEXPARTNERS !== null) {
    const ysp = n(data.YOUTH_SEXPARTNERS);
    if (ysp === 98) metrics.YOUTH_SEXPARTNERS = 0;
    else if (ysp < 2) metrics.YOUTH_SEXPARTNERS = 2;
    else metrics.YOUTH_SEXPARTNERS = ysp;
  } else {
    metrics.YOUTH_SEXPARTNERS = 0;
  }

  // ---------------------------
  // SEXACT3_SF / SEXACT4_SF + derived
  // ---------------------------
  const SEXACT3_SF = n(data.SEXACT3_SF);
  const SEXACT4_SF = n(data.SEXACT4_SF);

  metrics.SEXACT3_SF = SEXACT3_SF;
  metrics.SEXACT4_SF = SEXACT4_SF;

  if (data.SEXACT3_SF !== undefined && data.SEXACT3_SF !== null) {
    if (SEXACT3_SF > 4) {
      metrics.DrinkingBeforeSex = 4.4;
      metrics.AlcoholRelatedSexualConsequences = 7;
    } else {
      metrics.DrinkingBeforeSex = 0;
      metrics.AlcoholRelatedSexualConsequences = 0;
    }
  } else {
    metrics.DrinkingBeforeSex = 0;
    metrics.AlcoholRelatedSexualConsequences = 0;
  }

  // ---------------------------
  // RISK_FLAG (1 if ANY risk item in (0,2])
  // special: RSKNDL_INJECT == 98 -> treat as 0
  // ---------------------------
  const risk1  = n(data.RSKANYSEX_UNP);
  const risk2  = n(data.RSKSEX_ALCDRG);
  const risk3  = n(data.RiskOfHarmWhenUsingTobaccoOnceOrTwiceWeek);
  const risk4  = n(data.RSKALC);
  const risk5  = n(data.RSKMJ);
  const risk6  = n(data.RSKNDL_SHR);
  const risk7  = (data.RSKNDL_INJECT === 98 || data.RSKNDL_INJECT === "98") ? 0 : n(data.RSKNDL_INJECT);
  const risk8  = n(data.RiskOfHarmWhenUsingNonPrescriptionOpioidDrugsOnceOrTwiceWeek);
  const risk9  = n(data.RiskOfHarmWhenUsingPrescriptionOpioidDrugsOnceOrTwiceWeek);
  // your SQL duplicated these two; we mirror that behavior
  const risk10 = n(data.RSKANYSEX_UNP);
  const risk11 = n(data.RSKSEX_ALCDRG);

  let RISK_FLAG = 0;
  for (const v of [risk1, risk2, risk3, risk4, risk5, risk6, risk7, risk8, risk9, risk10, risk11]) {
    if (v > 0 && v <= 2) {
      RISK_FLAG = 1;
      break;
    }
  }
  metrics.RISK_FLAG = RISK_FLAG;

  // ---------------------------
  // ABUSE_FLAG
  // ---------------------------
  const abuse = n(data.ANYABUSE_3M);
  metrics.ABUSE_FLAG = abuse > 1 ? 1 : 0;

  // ---------------------------
  // SEXPARTNERS passthrough
  // ---------------------------
  metrics.SEXPARTNERS = n(data.SEXPARTNERS);

  return metrics;
}
export default calculateMetrics2; // ADD THIS